import {AppState} from '../../App.reducer'

export const isInternalSelector = (state: AppState) => state.loggedInUser.profile?.isInternal
